
import Vue from "vue";
import Component from "vue-class-component";
import WebpartManagement from "../components/webpart-manage/WebpartManagement.vue";
import webpartRegister, { RegisteredComponentInfo } from "@webparts/components/webparts/WebpartRegistration";
import { Watch } from "vue-property-decorator";
import { mapActions, mapGetters } from "vuex";
import * as accouttypes from "@account/store/types";
import * as typesWebpart from "@webparts/store/types";
import { FormGroup } from "@appbase/components/forms";
import { WebpartDataType } from "../types/enums";

const kebabCase = (value: string) =>
    value
        .replace(/([a-z])([A-Z])/g, "$1-$2")
        .replace(/[\s_]+/g, "-")
        .toLowerCase();

const getInitialWebpart = (comCode: string): webpartv3.Webpart => {
    return {
        comCode: comCode,
        title: "",
        titleEn: "",
        titleCh: "",
        titleJp: "",
        component: "",
        enabled: true,
        isFixedSize: true,
        columns: 1,
        rows: 1,
        props: null,
        roles: [],
    };
};

@Component({
    components: { WebpartManagement, FormGroup },
    computed: {
        ...mapGetters({
            current: accouttypes.CURRENT,
        }),
    },

    methods: {
        ...mapActions({
            loadCommonInfo: typesWebpart.WEBPART_COMMONDATA,
        }),
    },
})
export default class WebpartSampleView extends Vue {
    loadCommonInfo!: (types: WebpartDataType[]) => Promise<any>;

    current!: account.TCurrent;

    availableComponents: RegisteredComponentInfo[] = [];
    compo: string = "";
    webpart: webpartv3.Webpart | null = null;

    created() {
        this.loadCommonInfo([WebpartDataType.UnreadMail, WebpartDataType.MonthlyEvent, WebpartDataType.DailyEvent]).then((res) => {
            this.availableComponents = webpartRegister.components();
            this.webpart = getInitialWebpart(this.current.user.comCode);
        });
    }

    @Watch("compo")
    onCnameChanged(v: string) {
        this.compo = kebabCase(v);
    }
}
